import ViewFactory from "../helpers/viewfactory";
import { callback, getValueAtPath, isPlainObject } from "../../../utils";
import EventLog from "../../../logger/events";

export default function view() {
  const $this = isPlainObject(this) ? this : Object.create(null);

  return ViewFactory({
    NAME: 'REDIRECT_VIEW',

    constants: {
      get resetView() { 
        if (getValueAtPath($this, "STATE.method.current") === 'enaira') {
          return $this.cancelOption || null;
        } else if (getValueAtPath($this, "STATE.method.current") === 'account' && getValueAtPath($this, "STATE.currency.current") === 'ZAR') {
          return $this.cancelOption || null;
        } else if (getValueAtPath($this, "STATE.method.current") === 'account' && getValueAtPath($this, "STATE.currency.current") === 'NGN') {
          return $this.cancelOption || null;
        } 
        return null;
      },
    },

    next() { 
      let label, value;
      let currentPaymentMethod = getValueAtPath($this, "STATE.method.current")
      label = currentPaymentMethod
      value = currentPaymentMethod
      if (currentPaymentMethod === 'enaira') {
        value = `${label} ${getValueAtPath($this.$inputs.eNairaPaymentOption, 'value.name')}`
      }
      EventLog.customerOpenedRedirectURL(label, value);
      callback(getValueAtPath($this.$charge, 'redirect'))() 
    }
  }).call($this);
}
